import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// GET Today absence
// absences for the current day 
export const getAbsencesForToday = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/today`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absences for today');
  }
};

export const getUnifiedOutToday = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/unified-out-today`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch unified out today data');
  }
};

// GET This week absence
// absences for the current week 
export const getAbsencesForWeek = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/thisWeek`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absences for this week');
  }
};

export const getAbsencesForMonth = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/thisMonth`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absences for this Month');
  }
};

// GET all absences
export const getAbsencesByTypeAndMonth = async (ty_pe, year, month) => {
  const response = await api.get(`${API_URL}/absence/type-and-month`, {
    params: { ty_pe, year, month }
  });
  return response.data;
};

// GET all absences
export const getAllAbsences = async () => {
  const response = await api.get(`${API_URL}/absence/all`);
  return response.data;
};

// GET all staged absences
export const getAllStagedAbsences = async () => {
  const response = await api.get(`${API_URL}/absence/staged/all`);
  return response.data;
};

// GET absences for authenticated employee
export const getMyAbsences = async () => {
  const response = await api.get(`${API_URL}/absence/myAbsence`);
  return response.data;
};

// GET absences for authenticated employee
export const getMyStagedAbsences = async () => {
  const response = await api.get(`${API_URL}/absence/staged/myAbsence`);
  return response.data;
};

// POST new absence
export const createAbsence = async (absenceData) => {
  const response = await api.post(`${API_URL}/absence/add`, absenceData, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

// Notify about absence
export const stageAbsence = async (absenceData) => {
  const response = await api.post(`${API_URL}/absence/notify`, absenceData, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

// Confirm an absence notification 
export const confirmAbsence = async (id) => {
  const response = await api.post(`${API_URL}/absence/confirm`, `"${id}"`, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

// Unconfirm an absence notification 
export const unconfirmAbsence = async (id, reason) => {
  const requestBody = {
    id: id,
    reason: reason
  };
  const response = await api.post(`${API_URL}/absence/unconfirm`, requestBody, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

// GET absence details by ID`
export const getAbsenceDetails = async (id) => {
  const response = await api.get(`${API_URL}/absence/${id}`);
  return response.data;
};

// PUT update absence
export const updateAbsence = async (id, absenceData) => {
  const response = await api.put(`${API_URL}/absence/${id}`, absenceData, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

// PUT update absence
export const  markAsStored = async (id) => {
  const response = await api.put(`${API_URL}/absence/stored/${id}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

// DELETE absence
export const deleteAbsence = async (id) => {
  const response = await api.delete(`${API_URL}/absence/${id}`);
  return response.data;
};

// DELETE unconfirmed absence
export const deleteStagedAbsence = async (id) => {
  const response = await api.delete(`${API_URL}/absence/staged/${id}`);
  return response.data;
};


// POST justification for absence By HR
export const addJustificationByHR = async (id, reason, file) => {
  const formData = new FormData();
  formData.append('reason', reason);
  if (file) {
    formData.append('file', file);
  }
  
  const response = await api.post(`${API_URL}/absence/${id}/justifyByHR`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// POST justification for absence
export const addJustification = async (id, reason, file) => {
  const formData = new FormData();
  formData.append('reason', reason);
  if (file) {
    formData.append('file', file);
  }
  
  const response = await api.post(`${API_URL}/absence/${id}/justify`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// GET absence summary for all employees
export const getAllEmployeesAbsenceSummary = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/summary/all`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absence summary for all employees');
  }
};

// GET latest 10 absences by year, month, and office
export const getLatestAbsences = async (year, month, office) => {
  try {
    const params = new URLSearchParams({ year, office });
    if (month) {
      params.append('month', month);
    }
    const response = await api.get(`${API_URL}/absence/latest-filtered?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch latest absences');
  }
};

// GET absences by department, year, month, and office
export const getAbsencesByDepartment = async (year, month, office) => {
  try {
    const params = new URLSearchParams({ year, office });
    if (month) {
      params.append('month', month);
    }
    const response = await api.get(`${API_URL}/absence/by-department-filtered?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absences by department');
  }
};

// GET absence count by type for all employees by year, month, and office
export const getAllEmployeesAbsenceCountByType = async (year, month, office) => {
  try {
    const params = new URLSearchParams({ year, office });
    if (month) {
      params.append('month', month);
    }
    const response = await api.get(`${API_URL}/absence/summary/count-by-type-filtered?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absence count by type');
  }
};

// GET absence summary by employee and leave type
export const getAllEmployeesAbsenceSummaryByEmployeeAndType = async (year, month, office) => {
  try {
    const params = new URLSearchParams({ year, office });
    if (month) {
      params.append('month', month);
    }
    const response = await api.get(`${API_URL}/absence/summary/by-employee-and-type-filtered?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absence summary by employee and type');
  }
};

// GET absences for a specific employee by ID
export const getEmployeeAbsences = async (employeeId, year = null) => {
  const params = year ? { year } : {};
  const response = await api.get(`${API_URL}/absence/employee/${employeeId}`, { params });
  return response.data;
};

// GET absence statistics for a specific employee for current year
export const getEmployeeAbsenceStats = async (employeeId) => {
  const response = await api.get(`${API_URL}/absence/employee/${employeeId}/stats`);
  return response.data;
};
 
// GET Absence KPI Dashboard Data
export const getAbsenceKPIData = async (year, month, office) => {
  try {
    const params = new URLSearchParams({ year, office });
    if (month !== undefined && month !== null) {
      params.append('month', month);
    }
    console.log('Fetching KPI data with params:', { year, month, office });
    const response = await api.get(`${API_URL}/absence/kpi/dashboard`, {
      params, // This ensures proper encoding
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching KPI dashboard data:', error);
    throw new Error(
      error.response?.data?.message || 'Failed to fetch absence KPI data'
    );
  }
};

// __________  Employees Rates  __________

// GET employee absence analytics summaries
export const getEmployeeAbsenceSummaries = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/employee-summaries`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch employee absence summaries');
  }
};

export const getEmployeeLatenessSummaries = async (year = null) => {
  try {
    const params = year ? { year } : {};
    const response = await api.get(`${API_URL}/absence/employee-summaries/lateness`, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch employee lateness summaries');
  }
};

export const getEmployeeSicknessSummaries = async (year = null) => {
  try {
    const params = year ? { year } : {};
    const response = await api.get(`${API_URL}/absence/employee-summaries/sickness`, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch employee sickness summaries');
  }
};
export const getEmployeePersonalCommitmentsSummaries = async (year = null) => {
  try {
    const params = year ? { year } : {};
    const response = await api.get(`${API_URL}/absence/employee-summaries/personal`, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch employee personal commitments summaries');
  }
};


// GET high absence rate employees
export const getHighAbsenceEmployees = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/high-absence-employees`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch high absence employees');
  }
};

export const getHighLatenessEmployees = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/high-absence-employees/lateness`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch high lateness employees');
  }
};

export const getHighPersonalCommitmentEmployees = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/high-absence-employees/personal`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch high personal commitment employees');
  }
};

export const getHighSicknessEmployees = async () => {
  try {
    const response = await api.get(`${API_URL}/absence/high-absence-employees/sickness`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch high sickness employees');
  }
};


// __________  Employee Summery  __________

// GET absence summary by employee name
export const getAbsenceSummaryByName = async (name) => {
  try {
    const response = await api.get(`${API_URL}/absence/employee/summary`, {
      params: { name }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch absence summary for employee');
  }
};